import { observer } from 'mobx-react-lite'
import { type BookkeepingCompleteCycleDialogViewModel } from './BookkeepingCompleteCycleDialogViewModel'
import { type CompletedWorkItemViewModel } from './CompletedWorkItemViewModel'
import {
  BookkeepingCompleteCycleDialog,
  BookkeepingCompleteCycleDialogWorkItemRow,
} from '@/features/jobs/details/components/BookkeepingCompleteCycleDialog'

export interface BookkeepingCompleteCycleDialogContainerProps {
  vm: BookkeepingCompleteCycleDialogViewModel
}

export const BookkeepingCompleteCycleDialogContainer = observer(
  function BookkeepingCompleteCycleDialogContainer({
    vm,
  }: BookkeepingCompleteCycleDialogContainerProps) {
    return (
      <BookkeepingCompleteCycleDialog
        showing={vm.modal.showing}
        onClose={vm.modal.close}
        onSubmit={vm.submit}
        isSubmitPending={vm.submit.pending}
        itemCount={vm.itemsToComplete.length}
      >
        {vm.itemsToComplete.map((ci) => (
          <WorkItemRowContainer key={ci.workItemId} vm={ci} />
        ))}
      </BookkeepingCompleteCycleDialog>
    )
  },
)

interface WorkItemRowContainerProps {
  vm: CompletedWorkItemViewModel
}

const WorkItemRowContainer = observer(function WorkItemRowContainer({
  vm,
}: WorkItemRowContainerProps) {
  return (
    <BookkeepingCompleteCycleDialogWorkItemRow
      name={vm.inventoryItemName}
      description={vm.inventoryItemDescription}
      remaining={vm.remaining}
      min={vm.fieldLengths.completedItems.min}
      completedItems={vm.completedItems}
      isInvalid={Boolean(vm.validation.getError('completedItems'))}
      onCompletedItemsChange={vm.setCompletedItems}
    />
  )
})
